import Backbone from "backbone";
import $ from "jquery";
import _ from "underscore";

var STICKY_SPEC = {
        ABOVE: "PubliSticky--above", // au dessus
        BELOW: "PubliSticky--below", // en dessous
        FIXED: "PubliSticky--fixed",
        FIXEDMORE: "PubliSticky--fixedMore"
    },
        $STICKIES = $(".js-PubliSticky"),

        $nbStickies = $STICKIES.length,

        stickyViewInstances = [];


    /*
    *   $el : .js-PubliSticky //
    *   params (attr data) :
        *   data-sticky-level: 0 (by default) || 1 || ...
        *   data-sticky-action: "scroll" (by default) || "switch" || ...
        *   data-sticky-position: "top" (by default) || "aside" || "bottom"
    */
    export default Backbone.View.extend({


        /* INIT */

        initialize: function () {
          this.onUpdateState = this.onUpdateState.bind(this);
          this.onResize = this.onResize.bind(this);
          this.onScroll = this.onScroll.bind(this);

            stickyViewInstances.push(this);

            if ($nbStickies > 1 && stickyViewInstances.length === $nbStickies) {

                setTimeout(function () {
                    _.each(stickyViewInstances, function (stickyView) {
                        if (stickyView.stickyNavAction === "switch") {
                            stickyView.$navItems[0].click();
                        }
                    });
                }, 0);

            }

            this.initBase();
            this.initView();
            this.getSize();
            this.getPositions();
            this.setState();

            if ($nbStickies === 1) {
                this.render();
            }
            // EVENT LISTEN
            this.$el.on("updateState", this.onUpdateState);
            $(window)
                .on("resize.PubliStickyHeader", _.debounce(this.onResize, 300))
                .on("scroll.PubliStickyHeader", _.throttle(this.onScroll, 200));

        },


        initBase: function () {

            var $el = this.$el,
                $items,
                $nav,
                hasSubSticky = $el.find(".js-PubliSticky").length > 0 ? true : false,
                stickyLevel = $el.attr("data-sticky-level") || 0,
                stickyNavAction = $el.attr("data-sticky-action") || "scroll",
                stickyNavPosition = $el.attr("data-sticky-position") || "top";


            if (!hasSubSticky) { // no sub sticky
                $nav = $el.find(".js-PubliStickyNav");
                $items = $el.find(".js-PubliSticky-item");
            } else { //has sub sticky
                $nav = $el.find(".js-PubliStickyNav").filter(function () {
                    return $(this).parents(".js-PubliSticky").eq(0).attr("data-sticky-level") === stickyLevel;
                });
                $items = $el.find(".js-PubliSticky-item").filter(function () {
                    return $(this).closest(".js-PubliSticky").attr("data-sticky-level") === stickyLevel;
                });
            }

            this.$items = $items;
            this.$nav = $nav;
            this.$navItems = $nav.find(".js-PubliSticky-anchor");
            this.navClasses = $nav.attr("class");
            this.nbItems = $items.length;
            this.hasSubSticky = hasSubSticky;
            this.stickyLevel = parseInt(stickyLevel, 10);
            this.stickyNavAction = stickyNavAction;
            this.stickyNavPosition = stickyNavPosition;

        },


        initView: function () {

            var $el = this.$el,
                $navItems = this.$navItems,
                stickyLevel = this.stickyLevel,
                targets = [],
                $parent = null,
                parentSticky = {
                    cid: null,
                    type: null,
                    $el: null,
                    exist: false,
                    state: null,
                    navHeight: null,
                    currentItem: {
                        $el: null,
                        isVisible: false,
                        exist: false
                    }
                },
                switchElementFromParent = {
                    isHidden: false,
                    $el: null
                };


            if (stickyLevel > 0) {
                $parent = $el.parents(".js-PubliSticky").filter(function () {
                    return parseInt(this.getAttribute("data-sticky-level"), 10) === (stickyLevel - 1);
                });
                parentSticky.exist = true;
                parentSticky.$el = $parent;
                parentSticky.type = $parent.attr("data-sticky-action") || "scroll";
            }

            _.each($navItems, function (navItem) {
                var href = navItem.getAttribute("data-href") || navItem.getAttribute("href");
                targets.push({
                    id: href,
                    topPosition: null,
                    height: null
                });
            });

            this.targets = targets;
            this.parentSticky = parentSticky;

            if (parentSticky.type === "switch") {
                switchElementFromParent.$el = this.$el.closest(".js-PubliSticky-item");
                parentSticky.currentItem.$el = this.$el.closest(".js-PubliSticky-item");
                parentSticky.currentItem.exist = true;
            }

            this.switchElementFromParent = switchElementFromParent;
            this.state = null;
            this.navIndex = null;

        },




        /* EVENTS */

        events: {

            "click .js-PubliSticky-anchor": "goToAnchor"

        },


        onResize: function () {

            this.getSize();
            this.getPositions();
            this.setState();
            this.render();

        },


        onScroll: function () {

            var parentStickyCurrentItem = this.parentSticky.currentItem;

            if (parentStickyCurrentItem.exist && !parentStickyCurrentItem.isVisible) {
                return;
            }

            this.setNavState();

            if (this.stickyNavAction === "scroll") {
                this.setAnchorState(this.navIndex);
            }

            this.render();
        },


        onUpdateState: function (event, data) {

            if (event.target !== event.delegateTarget) {
                return;
            }

            this.parentSticky.state = data.state;

        },



        /* SIZES */

        getSize: function () {

            this.getHeaderSize();
            this.getElementSize();

        },


        getHeaderSize: function () {

            var parentSticky = this.parentSticky,
                $navHeight = this.$nav.outerHeight(),
                navHeight = this.stickyNavPosition === "top" ? $navHeight : 0,
                parentHeight = 0;

            if (parentSticky.exist) {
                parentHeight = parentSticky.$el.children(".js-PubliStickyNav").eq(0).outerHeight();
                navHeight += parentHeight;
            }

            this.headerHeight = $(".js-Header").eq(0).height();
            this.navHeight = navHeight;
            this.$navHeight = $navHeight;
            this.fullHeaderHeight = (this.headerHeight + navHeight);
            this.parentSticky.navHeight = parentHeight;

        },


        getElementSize: function () {

            var $el = this.$el,
                navHeight = this.navHeight,
                headerHeight = this.headerHeight,
                targets = this.targets,
                $elHeight = Math.floor($el.outerHeight()),
                windowHeight = $(window).height(),
                stickyNavAction = this.stickyNavAction;

            _.each(targets, function (target) {

                var $target = $(target.id);

                target.height = $target.outerHeight();

                if (stickyNavAction === "switch") {
                    $elHeight = Math.max($elHeight, target.height);
                }

            });

            this.windowHeight = windowHeight;
            this.isOkForSticky = navHeight < (windowHeight - headerHeight);
            this.$elHeight = $elHeight;

        },




        /* POSITIONS */

        getPositions: function () {

            this.getElementPositions();
            this.getTargetsPositions();

        },


        getElementPositions: function () {

            var $el = this.$el,
                $nav = this.$nav,
                navHeight = this.navHeight,
                headerHeight = this.headerHeight,
                windowHeight = this.windowHeight,
                parentSticky = this.parentSticky,
                $elTop = Math.floor($el.offset().top),
                $elEnd;

            $elEnd = ($elTop + this.$elHeight) - (navHeight + headerHeight);

            if (parentSticky.exist && parentSticky.state !== "FIXED") {
                $elTop -= navHeight;
            }

            if (this.stickyNavPosition === "aside") {
                $elEnd -= (Math.floor(windowHeight / 2) - $nav.outerHeight());
            }

            this.$elTop = $elTop - headerHeight;
            this.$elFixedTop = $elTop - (navHeight + headerHeight);
            this.$elEnd = $elEnd;
            if ($('.TopBar').length > 0) {
                this.headerHeight += $('.TopBar').height();
                this.$elFixedTop -= $('.TopBar').height();
            }

        },


        getTargetsPositions: function () {

            var stickyNavAction = this.stickyNavAction,
                $elFixedTop = this.$elFixedTop,
                targets = this.targets;

            _.each(targets, function (target, n) {

                var prevTarget = (n > 0) ? targets[n - 1] : { topPosition: $elFixedTop, height: 0 },
                    targetTop;

                if (stickyNavAction !== "switch") {
                    targetTop = $(target.id).attr("data-sticky-targetPos") || prevTarget.topPosition + prevTarget.height;
                } else {
                    targetTop = $(target.id).attr("data-sticky-targetPos") || $elFixedTop;
                }

                target.topPosition = targetTop;

            });

        },




        /* STATES */

        setState: function () {

            this.setNavState();
            this.setAnchorState(this.navIndex);

        },


        setNavState: function () {

            var nextNavState = null,
                switchParentItem = this.parentSticky.currentItem,
                switchHiddenState = false,
                yOffset = window.pageYOffset,
                $elFixedTop = this.$elFixedTop,
                realTop = $elFixedTop;


            if (this.isOkForSticky) {

                if (switchParentItem.exist && !switchParentItem.$el.hasClass("isSwitchVisible")) {
                    nextNavState = "ABOVE";
                    switchHiddenState = true;
                } else {
                    if (yOffset < realTop) {
                        nextNavState = "ABOVE";
                    } else if ($('.TopBar ').length > 0) {
                        nextNavState = "FIXEDMORE";
                    } else {
                      var isHeaderPresent = !$(".js-header").hasClass("scrolled-header");
                      var navHeight = isHeaderPresent ? this.navHeight : 0;

                      if ((yOffset - navHeight) < this.$elEnd) {
                        nextNavState = (isHeaderPresent) ? "FIXED" : "FIXEDNOHEADER";
                      } else {
                        nextNavState = "BELOW";
                      }
                    }
                }

            } else {
                nextNavState = "ABOVE";
            }

            if (this.hasSubSticky) {
                this.$el.find(".js-PubliSticky").triggerHandler("updateState", { state: nextNavState, height: this.navHeight });
            }

            if (this.state === nextNavState) {
                return;
            }

            this.state = nextNavState;
            this.switchElementFromParent.isHidden = switchHiddenState;

        },


        setAnchorState: function (navIndex) {

            var windowPos = window.pageYOffset,
                total = this.nbItems - 1;

            _.each(this.targets, function (target, n) {

                var nextTopPos = n < total ? this.targets[n + 1].topPosition : false,
                    $anchor = this.$(".js-PubliSticky-anchor[href='" + target.id + "']");

                if (!_.isNull(navIndex)) {
                    if (n === navIndex) {
                        $anchor.addClass("isActive");
                    } else {
                        $anchor.removeClass("isActive");
                    }
                } else {
                    if (((windowPos >= target.topPosition && n < total) && (windowPos < nextTopPos)) || ((windowPos >= target.topPosition) && !nextTopPos)) {
                        $anchor.addClass("isActive");
                    } else {
                        $anchor.removeClass("isActive");
                    }
                }

            }, this);

        },




        /* ACTION */

        goToAnchor: function (e) {

            e.preventDefault();

            var $trigger = $(e.currentTarget),
                hash,
                index;

            if (!$trigger.closest(".js-PubliSticky").is($(e.delegateTarget))) {
                // if the delegateTarget is not the closest parent
                return;
            }

            hash = $trigger.attr("href");
            index = _.indexOf(this.targets, _.findWhere(this.targets, { id: hash }));

            this[this.stickyNavAction + "ToAnchor"]({
                hash: hash,
                index: index
            });

        },


        switchToAnchor: function (obj) {

            var top = this.targets[0].topPosition,
                state = this.state,
                $target = $(obj.hash);

            this.navIndex = obj.index;
            this.setAnchorState(obj.index);
            this.$items.removeClass("isSwitchVisible");
            $target.addClass("isSwitchVisible");
            this.updateSwitchedViews($target);

            if (state === "ABOVE" || _.isNull(state)) {
                return;
            }

            $("body, html")
                .stop()
                .animate(
                    { scrollTop: top },
                    { duration: 0 }
                );

        },


        scrollToAnchor: function (obj) {

            var index = obj.index,
                fullHeaderHeight = this.fullHeaderHeight,
                top;

            top = (index >= 0) ? this.targets[index].topPosition : $(obj.hash).offset().top - fullHeaderHeight;

            $("body, html")
                .stop()
                .animate({ scrollTop: top }, 600, "swing");

        },



        /* RENDER */

        updateSwitchedViews: function ($switched) {

            var self = this;

            _.each(stickyViewInstances, function (stickyView) {

                var switchElementParent = stickyView.parentSticky.currentItem; //stickyView.switchElementFromParent.$el;

                if (switchElementParent.exist) {

                    if (switchElementParent.$el.is($switched)) {
                        stickyView.parentSticky.currentItem.isVisible = true;
                        stickyView.$el.trigger("updateState", { state: self.state, height: self.navHeight });
                        stickyView.getPositions();
                    } else {
                        stickyView.parentSticky.currentItem.isVisible = false;
                    }

                    stickyView.setState();
                    stickyView.render();
                }

            });

        },


        render: function () {

            this.$nav
                .removeClass()
                .prop("className", this.navClasses + " " + STICKY_SPEC[this.state]);

        }


    });
